var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<section class=\"text-center-xs-down\"><div class=\"regular-container\"><div ng-switch=\"::verifyCtrl.isExpired\"><span ng-switch-when=\"true\">Your confirmation code has expired. Please re-submit your information in the Opendoor app.</span><span ng-switch-default>Your confirmation code is<b> {{::verifyCtrl.confirmationCode}}</b>. Please enter it into the Opendoor app.</span></div></div></section>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/verify.jade
 ** module id = 3621
 ** module chunks = 3
 **/